/**
 * Experience API 패키지 URL
 * @type {string}
 */
const packages = {
    services: `/services`,
    support: `/support`,
    transfer: `/transfer`,
};
/**
 * Experience API 업무 구분 URL
 * @type {string}
 */
const sectors = {
    services: {
        openbanking: `${packages.services}/openbanking`,
        guest: `${packages.services}/guest`,
        notification: `${packages.services}/notification`,
    },
    support: {
        info: `${packages.support}/info`,
        report: `${packages.support}/report`,
        location: `${packages.support}/location`,
        consult: `${packages.support}/consult`,
    },
    transfer: {
        schedule: `${packages.transfer}/schedule`,
    },
};
/**
 * Experience API 업무 세구분 URL
 * @type {string}
 */
const details = {
    services: {
        openbanking: {
            findList: `${sectors.services.openbanking}/findList`,
            setting: `${sectors.services.openbanking}/setting`,
            mainExcute: `${sectors.services.openbanking}/mainExcute`,
            validate: `${sectors.services.openbanking}/validate`,
        },
        guest: {
            findList: `${sectors.services.guest}/findList`,
            findDetail: `${sectors.services.guest}/findDetail`,
            mainExcute: `${sectors.services.guest}/mainExcute`,
            setting: `${sectors.services.guest}/setting`,
        },
        notification: {
            mainExcute: `${sectors.services.notification}/mainExcute`,
            findList: `${sectors.services.notification}/findList`,
            findDetail: `${sectors.services.notification}/findDetail`,
            setting: `${sectors.services.notification}/setting`,
            validate: `${sectors.services.notification}/validate`,
        },
    },
    support: {
        info: {
            findList: `${sectors.support.info}/findList`,
            findDetail: `${sectors.support.info}/findDetail`,
            inquiry: `${sectors.support.info}/inquiry`,
            setting: `${sectors.support.info}/setting`,
            mainExcute: `${sectors.support.info}/mainExcute`,
        },
        report: {
            findList: `${sectors.support.report}/findList`,
            preExcute: `${sectors.support.report}/preExcute`,
            mainExcute: `${sectors.support.report}/mainExcute`,
        },
        location: {
            findList: `${sectors.support.location}/findList`,
        },
        consult: {
            findDetail: `${sectors.support.consult}/findDetail`,
            mainExcute: `${sectors.support.consult}/mainExcute`,
        },
    },
    transfer: {
        schedule: {
            findList: `${sectors.transfer.schedule}/findList`,
        },
    },
};
/**
 * Experience API 엔드포인트 URL
 * @type {string}
 */
export const APIS = {
    services: {
        openbanking: {
            findList: {
                //  타행출금계좌 조회
                listOpenBankingExternalWithdrawalAccountInquiry: `${details.services.openbanking.findList}/listOpenBankingExternalWithdrawalAccountInquiry`,
                //  타행출금계좌 선택
                listOpenBankingExternalBankAccountSelection: `${details.services.openbanking.findList}/listOpenBankingExternalBankAccountSelection`,
                //  오픈뱅킹 > 제3자 정보제공 재동의 > 계좌 선택
                listTermsReAgree: `${details.services.openbanking.findList}/listTermsReAgree`,
            },
            setting: {
                //  타행출금계좌 삭제 선택"
                setOpenBankingExternalWithdrawalAccountDeletion: `${details.services.openbanking.setting}/setOpenBankingExternalWithdrawalAccountDeletion`,
                // 타행출금계좌 약관동의
                authorizeOpenBankingExternalWithdrawalAccountTermsAgreement: `${details.services.openbanking.setting}/authorizeOpenBankingExternalWithdrawalAccountTermsAgreement`,
                // 타행출금계좌 전자서명
                authorizeOpenBankingExternalBankAccountElectronicSignature: `${details.services.openbanking.setting}/authorizeOpenBankingExternalBankAccountElectronicSignature`,
                // 이용동의기간 연장
                applyOpenBankingConsentPeriodExtension: `${details.services.openbanking.setting}/applyOpenBankingConsentPeriodExtension`,
            },
            mainExcute: {
                //  타행출금계좌 삭제
                deleteOpenBankingExternalWithdrawalAccountDeletion: `${details.services.openbanking.mainExcute}/deleteOpenBankingExternalWithdrawalAccountDeletion`,
                //  타행출금계좌 등록
                registerOpenBankingExternalBankAccountRegistration: `${details.services.openbanking.mainExcute}/registerOpenBankingExternalBankAccountRegistration`,
                //  이용동의기간 연장완료
                authorizeOpenBankingConsentPeriodExtensionCompleted: `${details.services.openbanking.mainExcute}/authorizeOpenBankingConsentPeriodExtensionCompleted`,
                //  오픈뱅킹 제3자 정보제공 재동의 처리
                updateTermsReAgree: `${details.services.openbanking.mainExcute}/updateTermsReAgree`,
            },
            validate: {
                //  타행출금계좌 등록완료
                confirmOpenBankingExternalBankAccountRegistrationCompleted: `${details.services.openbanking.validate}/confirmOpenBankingExternalBankAccountRegistrationCompleted`,
                //  오픈뱅킹 신규 가입자 이체 3일 제한
                validateNewSubscriptionThreeDayCheck: `${details.services.openbanking.validate}/validateNewSubscriptionThreeDayCheck`,
            },
        },
        guest: {
            findList: {
                // 스피드조회 > 계좌목록
                listAccountSpeedSearch: `${details.services.guest.findList}/listAccountSpeedSearch`,
                // 스피드조회 > 목록조회
                listSpeedAccountListInquiry: `${details.services.guest.findList}/listSpeedAccountListInquiry`,
                // 스피드조회 > 예금펀드거래내역조회
                listDepositandFundTransactionInquiry: `${details.services.guest.findList}/listDepositandFundTransactionInquiry`,
                // 스피드조회 > 요구불거래내역조회
                listDemandAccountTransactionInquiry: `${details.services.guest.findList}/listDemandAccountTransactionInquiry`,
                // 스피드조회 > 외화거래내역조
                listForeignCurrencyTransactionInquiry: `${details.services.guest.findList}/listForeignCurrencyTransactionInquiry`,
            },
            findDetail: {
                // 스피드조회 > 예금잔액 증명서
                getDepositBalanceCertificate: `${details.services.guest.findDetail}/getDepositBalanceCertificate`,
                // 스피드조회 > 금융거래 부채증명서 발급내역
                getFindIssuedCertificates: `${details.services.guest.findDetail}/getFindIssuedCertificates`,
                // 스피드조회 > 금융거래 확인
                getFinancialTransactionConfirmation: `${details.services.guest.findDetail}/getFinancialTransactionConfirmation`,
                // 스피드조회 > 부채잔액 증명
                getLiabilityBalanceCertificate: `${details.services.guest.findDetail}/getLiabilityBalanceCertificate`,
            },
            mainExcute: {
                // 스피드조회 > 등록삭제
                updateSpeedInquiryManagement: `${details.services.guest.mainExcute}/updateSpeedInquiryManagement`,
            },
            setting: {
                // 스피드조회 > 거래내역세션정리
                setTransactionHistorySessionCleanup: `${details.services.guest.setting}/setTransactionHistorySessionCleanup`,
            },
        },
        notification: {
            mainExcute: {
                // 푸시알림 서비스 가입
                applyPushAlarmService: `${details.services.notification.mainExcute}/applyPushAlarmService`,
                // 알림 서비스 등록 및 변경
                updateAlarmService: `${details.services.notification.mainExcute}/updateAlarmService`,
                // 입출금 내역 푸시 등록/수정/삭제
                updateTransferPush: `${details.services.notification.mainExcute}/updateTransferPush`,
                // 환율 푸쉬알림 등록/수정/삭제
                updateRatePushAlarm: `${details.services.notification.mainExcute}/updateRatePushAlarm`,
                // 서비스 알림 동의 등록/수정
                updateServicePushAlarm: `${details.services.notification.mainExcute}/updateServicePushAlarm`,
            },
            findList: {
                // 환율 조회
                listPushRate: `${details.services.notification.findList}/listPushRate`,
            },
            findDetail: {
                // 입출금 내역 푸시 설정 화면 호출 및 설정 계좌 조회
                setTransferListPushSettingPage: `${details.services.notification.findDetail}/setTransferListPushSettingPage`,
                // 상세 조회 및 상세설정 화면
                setDetailSettingPage: `${details.services.notification.findDetail}/setDetailSettingPage`,
            },
            setting: {
                // 푸시 알림 서비스 설정 팝업
                setPushAlarmServicePop: `${details.services.notification.setting}/setPushAlarmServicePop`,
                // 마케팅 혜택 안내 팝업
                setMarketingNoticePop: `${details.services.notification.setting}/setMarketingNoticePop`,
            },
            validate: {
                // 푸시 알림 서비스 설정화면 화면을 호출 및 푸시 가입여부를 조회
                confirmPushJoinYn: `${details.services.notification.validate}/confirmPushJoinYn`,
            },
        },
    },
    support: {
        info: {
            findList: {
                //고객센터 > 계약서류제공 계좌목록 조회
                listDocProvisionAccount: `${details.support.info.findList}/listDocProvisionAccount`,

                //계약서류제공 수신(입출금, 예금, 적금) 신청내역조회
                listDepositAndWithdrawal: `${details.support.info.findList}/listDepositAndWithdrawal`,

                //계약서류제공 신탁 계약서 신청내역조회
                listTrustAccount: `${details.support.info.findList}/listTrustAccount`,

                //계약서류제공  펀드 신청내역조회
                listFund: `${details.support.info.findList}/listFund`,

                //계약서류제공  외화(보통예금, 정기예금) 신청내역 조회
                listForeign: `${details.support.info.findList}/listForeign`,

                //계약서류제공  카드 신청내역조회
                listCard: `${details.support.info.findList}/listCard`,

                //계약서류제공  여신(대출) 신청내역조회
                listApply: `${details.support.info.findList}/listApply`,

                //고객센터 > 공지사항 목록 조회
                listNotice: `${details.support.info.findList}/listNotice`,
            },

            findDetail: {
                //고객센터 > 공지사항 상세
                getNoticeDetail: `${details.support.info.findDetail}/getNoticeDetail`,
                //고객센터 > 이용시간 안내 시간 조회
                getBusinessHour: `${details.support.info.findDetail}/getBusinessHour`,
                //고객센터 > 신탁 계약서 조회
                getTrustAccountDetail: `${details.support.info.findDetail}/getTrustAccountDetail`,
                //고객센터 > 펀드 계약서 조회
                getFundDetail: `${details.support.info.findDetail}/getFundDetail`,
                //EDMS 계약서류조회 PDF 다운로드진행
                getEdmsPdfFile: `${details.support.info.findDetail}/getEdmsPdfFile`,
            },

            inquiry: {
                // 고객센터 > 본인정보 이용 및 제공
                getCustInfo: `${details.support.info.inquiry}/getCustInfo`,
                // 고객센터 > 개인정보 열람
                getAccessData: `${details.support.info.inquiry}/getAccessData`,
                // 고객센터 > 개인채무자 보호법 예정통지 조회
                getAdvanceNotice: `${details.support.info.inquiry}/getAdvanceNotice`,
            },

            setting: {
                //고객센터> 마케팅 동의
                setMarketingTermsPage: `${details.support.info.setting}/setMarketingTermsPage`,
                //고객센터 > 마케팅 동의/변경 본거래
                updateMarketingTerms: `${details.support.info.setting}/updateMarketingTerms`,
            },
            mainExcute: {
                applyEvent: `${details.support.info.mainExcute}/applyEvent`,
                // 고객센터 > 계약서류제공 EDMS 계약서류조회 PDF 조회 , 다운로드횟수 증가
                updateEdmsPdfFileDownloadCount: `${details.support.info.mainExcute}/updateEdmsPdfFileDownloadCount`,
            },
        },

        report: {
            findList: {
                //  고객센터 > 분실신고 > 통장인감 사고신고 등록 계좌조회
                listBankbookAccidentReport: `${details.support.report.findList}/listBankbookAccidentReport`,
                //고객센터 > 분실신고 > 사고신고 신용카드 조회
                listCreditCardAccident: `${details.support.report.findList}/listCreditCardAccident`,
                //고객센터 > 분실신고 > 사고신고 현금/직불카드 조회
                listCashAndCheckCardAccident: `${details.support.report.findList}/listCashAndCheckCardAccident`,
                //고객센터 > 분실신고 > 사고신고 자기앞수표 사고신고 조회
                listCashiersCheckAccident: `${details.support.report.findList}/listCashiersCheckAccident`,
            },

            preExcute: {
                // 고객센터 > 분실신고 > 통장인감 사고신고 등록 예비거래
                createBankbookAccidentReport: `${details.support.report.preExcute}/createBankbookAccidentReport`,
                //고객센터 > 분실신고 > OTP/보안카드 사고신고 예비거래
                createOtpSecretCard: `${details.support.report.preExcute}/createOtpSecretCard`,
                //고객센터 > 분실신고 > OTP/보안카드 분실신고 해제 예비거래
                createReleaseLostReport: `${details.support.report.preExcute}/createReleaseLostReport`,
            },
            mainExcute: {
                // 고객센터 > 분실신고 > 통장인감 사고신고 등록 본거래
                applyBankbookAccidentReport: `${details.support.report.mainExcute}/applyBankbookAccidentReport`,
                // 고객센터 > 분실신고 > 신용카드 사고신고 등록 본거래
                applyCreditCardAccident: `${details.support.report.mainExcute}/applyCreditCardAccident`,

                // 고객센터 > 분실신고 > 현금/직불 카드 사고신고 등록 본거래
                applyCashAndCheckCardAccident: `${details.support.report.mainExcute}/applyCashAndCheckCardAccident`,

                // 고객센터 > 분실신고 > 신용(체크)카드 분실일괄신고 본거래
                applyCreditCardLost: `${details.support.report.mainExcute}/applyCreditCardLost`,
                // 고객센터 > 분실신고 > 자기앞수표 사고신고 등록 본거래
                applyCashiersCheckAccident: `${details.support.report.mainExcute}/applyCashiersCheckAccident`,
                //고객센터 > 분실신고 > OTP/보안카드 사고신고 등록 본거래
                applyOtpSecretCard: `${details.support.report.mainExcute}/applyOtpSecretCard`,
                //고객센터 > 분실신고 > OTP/보안카드 분실신고 해제 본거래
                applyReleaseLostReport: `${details.support.report.mainExcute}/applyReleaseLostReport`,
            },
        },
        location: {
            findList: {
                //고객센터 > 영업점/ATM찾기
                findBranchAtm: `${details.support.location.findList}/findBranchAtm`,
                //고객센터 > 해외 ATM/영업점 찾기
                findForeignBranchAtm: `${details.support.location.findList}/findForeignBranchAtm`,
                // 고객센터 >  해외 영업점 카테고리를 검색
                findForeignBranchCategory: `${details.support.location.findList}/findForeignBranchCategory`,
            },
        },
        consult: {
            // 고객센터 > 전화상담예약파라미터 전달
            findDetail: {
                getPhoneConsultation: `${details.support.consult.findDetail}/getPhoneConsultation`,
            },
            mainExcute: {
                // 고객센터 > 찾아가는뱅킹 전문을 호출
                applyPhoneConsultation: `${details.support.consult.mainExcute}/applyPhoneConsultation`,
            },
        },
    },
    transfer: {
        schedule: {
            findList: {
                // 타행자동이체 관리 목록 조회
                listOpenbankingAutoTransfer: `${details.transfer.schedule.findList}/listOpenbankingAutoTransfer`,
            },
        },
    },
};
